<kendo-formerror *ngIf="showErrors">
        <ng-content></ng-content>
</kendo-formerror>
